export const PROMOTIONS = 'salePrice'

export const PROMOTIONS_IVA = 'ivaDiscount'
